export const ueberUnsSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "SubmenuLink",
          label: "Redaktion",
          link: "/ueber-uns/redaktion",
        },
        {
          type: "SubmenuLink",
          label: "Team",
          link: "/ueber-uns/team",
        },
        {
          type: "SubmenuLink",
          label: "Kontakt",
          link: "/ueber-uns/kontakt",
        },
        {
          type: "SubmenuLink",
          label: "Mediadaten",
          link: "/ueber-uns/media",
        },
        {
          type: "SubmenuLink",
          label: "Newsletter",
          link: "/newsletter-anmeldung",
        },
        {
          type: "SubmenuLink",
          label: "Presse",
          link: "/ueber-uns/presse",
        },
      ]
    : []
